import { DelayType } from './types'

export abstract class BaseDelayType {
  type!: DelayType
}
